
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire001c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire001c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cuPh8", function(module, exports) {

$parcel$export(module.exports, "readSaved", () => $91900f9c9606830c$export$e63c091f2ff08cc);
$parcel$export(module.exports, "save", () => $91900f9c9606830c$export$a1544dad697b423d);
$parcel$export(module.exports, "savedScore", () => $91900f9c9606830c$export$a1a7e8a3422aeb2c);
const $91900f9c9606830c$var$sessionValues = new Map();
function $91900f9c9606830c$export$e63c091f2ff08cc(key, fallback = '') {
    try {
        return localStorage.getItem(key) ?? $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    } catch  {
        return $91900f9c9606830c$var$sessionValues.get(key) ?? fallback;
    }
}
function $91900f9c9606830c$export$a1544dad697b423d(key, value) {
    $91900f9c9606830c$var$sessionValues.set(key, String(value));
    try {
        localStorage.setItem(key, String(value));
        return true;
    } catch  {
        return false;
    }
}
function $91900f9c9606830c$export$a1a7e8a3422aeb2c(key) {
    const score = Number($91900f9c9606830c$export$e63c091f2ff08cc(key, '0'));
    return Number.isFinite(score) && score > 0 ? Math.floor(score) : 0;
}

});

// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var $947b03da4811c942$var$module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), $947b03da4811c942$var$module, false);
var // end source content
$947b03da4811c942$export$2e2bcd8739ae039 = $947b03da4811c942$var$module.exports;
var $947b03da4811c942$export$185802fd694ee1f5 = $947b03da4811c942$var$module.exports.create;



var $cuPh8 = parcelRequire("cuPh8");

var $cuPh8 = parcelRequire("cuPh8");
const $51550fb3c0c2bcb1$var$games = [
    ...document.querySelectorAll('[data-game]')
];
function $51550fb3c0c2bcb1$var$refreshScores() {
    document.querySelectorAll('[data-score]').forEach((el)=>{
        el.textContent = `Your best: ${(0, $cuPh8.savedScore)(el.dataset.score).toLocaleString()}`;
    });
    const last = $51550fb3c0c2bcb1$var$games.find((game)=>game.dataset.game === (0, $cuPh8.readSaved)('arcade-last-game'));
    const link = document.getElementById('last-game');
    if (last) {
        link.href = last.href;
        link.textContent = `Back to ${last.querySelector('strong').textContent}`;
        link.hidden = false;
    }
}
$51550fb3c0c2bcb1$var$games.forEach((game)=>game.addEventListener('click', ()=>(0, $cuPh8.save)('arcade-last-game', game.dataset.game)));
document.getElementById('random-game').onclick = ()=>$51550fb3c0c2bcb1$var$games[Math.floor(Math.random() * $51550fb3c0c2bcb1$var$games.length)].click();
window.addEventListener('pageshow', $51550fb3c0c2bcb1$var$refreshScores);
$51550fb3c0c2bcb1$var$refreshScores();
const $51550fb3c0c2bcb1$var$sound = document.getElementById('site-sound');
const $51550fb3c0c2bcb1$var$syncSound = ()=>{
    const muted = (0, $cuPh8.readSaved)('site-muted') === 'true';
    $51550fb3c0c2bcb1$var$sound.textContent = muted ? "\uD83D\uDD07" : "\uD83D\uDD0A";
    $51550fb3c0c2bcb1$var$sound.setAttribute('aria-pressed', String(muted));
    $51550fb3c0c2bcb1$var$sound.setAttribute('aria-label', muted ? 'Unmute site sounds' : 'Mute site sounds');
    document.querySelectorAll('audio').forEach((audio)=>{
        audio.muted = muted;
    });
};
$51550fb3c0c2bcb1$var$sound.onclick = ()=>{
    (0, $cuPh8.save)('site-muted', (0, $cuPh8.readSaved)('site-muted') !== 'true');
    $51550fb3c0c2bcb1$var$syncSound();
};
$51550fb3c0c2bcb1$var$syncSound();
const $51550fb3c0c2bcb1$var$headlines = [
    'Local man calls meeting that could have been a honk.',
    'Jim announces Lunch 2.0. Critics preferred the original.',
    "Nissan Versa named Jim\u2019s car of the year. Again.",
    "Jim says \u201Cquick question.\u201D Area productivity collapses.",
    'Study finds Jim is still the leading cause of Jim.',
    'Jim seen replying all. Investigation ongoing.',
    'Man with 47 browser tabs says your computer is slow.',
    "Jim\u2019s five-minute story enters its third fiscal quarter.",
    "Local man describes parking job as \u201Cclose enough.\u201D",
    'Jim marks himself essential. Evidence remains inconclusive.'
];
const $51550fb3c0c2bcb1$var$now = new Date();
const $51550fb3c0c2bcb1$var$day = Math.floor(Date.UTC($51550fb3c0c2bcb1$var$now.getFullYear(), $51550fb3c0c2bcb1$var$now.getMonth(), $51550fb3c0c2bcb1$var$now.getDate()) / 86400000);
document.getElementById('report-date').textContent = $51550fb3c0c2bcb1$var$now.toLocaleDateString(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
});
document.getElementById('daily-headline').textContent = $51550fb3c0c2bcb1$var$headlines[$51550fb3c0c2bcb1$var$day % $51550fb3c0c2bcb1$var$headlines.length];
const $51550fb3c0c2bcb1$var$excuses = [
    "\u201CThat sounds like a problem for Future Jim.\u201D",
    "\u201CThe Versa would never do this to me.\u201D",
    "\u201CI was on lunch. The second one.\u201D",
    "\u201CIn my defense, I thought reply-all meant all my friends.\u201D",
    "\u201CHave you tried lowering your expectations?\u201D",
    "\u201CI would like to speak to the webmaster.\u201D"
];
let $51550fb3c0c2bcb1$var$excuse = 0;
document.getElementById('excuse-btn').onclick = ()=>{
    document.getElementById('jim-excuse').textContent = $51550fb3c0c2bcb1$var$excuses[$51550fb3c0c2bcb1$var$excuse++ % $51550fb3c0c2bcb1$var$excuses.length];
};
// User content always becomes text nodes, including entries loaded from storage.
let $51550fb3c0c2bcb1$var$entries = [];
try {
    const stored = JSON.parse((0, $cuPh8.readSaved)('jim-guestbook', '[]'));
    if (Array.isArray(stored)) $51550fb3c0c2bcb1$var$entries = stored.filter((e)=>typeof e.name === 'string' && typeof e.message === 'string').slice(0, 20);
} catch  {}
const $51550fb3c0c2bcb1$var$list = document.getElementById('guestbook-entries');
function $51550fb3c0c2bcb1$var$renderEntries() {
    $51550fb3c0c2bcb1$var$list.replaceChildren();
    if (!$51550fb3c0c2bcb1$var$entries.length) {
        const empty = document.createElement('li');
        empty.textContent = 'No signatures yet. Jim assumes this means universal approval.';
        $51550fb3c0c2bcb1$var$list.append(empty);
    }
    $51550fb3c0c2bcb1$var$entries.forEach((entry, index)=>{
        const li = document.createElement('li');
        const name = document.createElement('strong');
        name.textContent = entry.name.slice(0, 32);
        const message = document.createElement('p');
        message.textContent = entry.message.slice(0, 240);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', `Remove entry by ${name.textContent}`);
        remove.onclick = ()=>{
            $51550fb3c0c2bcb1$var$entries.splice(index, 1);
            (0, $cuPh8.save)('jim-guestbook', JSON.stringify($51550fb3c0c2bcb1$var$entries));
            $51550fb3c0c2bcb1$var$renderEntries();
        };
        li.append(name, message, remove);
        $51550fb3c0c2bcb1$var$list.append(li);
    });
}
$51550fb3c0c2bcb1$var$renderEntries();
document.getElementById('guestbook-form').onsubmit = (e)=>{
    e.preventDefault();
    const name = document.getElementById('guest-name').value.trim();
    const message = document.getElementById('guest-message').value.trim();
    const status = document.getElementById('guestbook-status');
    if (!name || !message) {
        status.textContent = 'Add your name and a review first.';
        return;
    }
    $51550fb3c0c2bcb1$var$entries.unshift({
        name: name.slice(0, 32),
        message: message.slice(0, 240)
    });
    $51550fb3c0c2bcb1$var$entries = $51550fb3c0c2bcb1$var$entries.slice(0, 20);
    const persisted = (0, $cuPh8.save)('jim-guestbook', JSON.stringify($51550fb3c0c2bcb1$var$entries));
    $51550fb3c0c2bcb1$var$renderEntries();
    document.getElementById('guest-message').value = '';
    status.textContent = persisted ? "Signed. Saved in this browser. Jim\u2019s approval rating remains unchanged." : 'Signed for this visit. Your browser is blocking saved entries.';
};



// Balloons handling: prefer global from CDN, fallback to dynamic import, then custom
// Party mode tracking
let $aaf54fe06afda49f$var$partyModeCounter = 0; // Cycles through 3 party modes: 0=confetti, 1=rainbow, 2=balloons
function $aaf54fe06afda49f$export$203df52ee0fb1907() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const mainTitle = document.getElementById('main-title');
    // Cycle through 3 different party modes
    switch($aaf54fe06afda49f$var$partyModeCounter % 3){
        case 0:
            console.log("\uD83C\uDF8A Professional Confetti Party Mode");
            mainTitle?.classList.add('rainbow-text');
            document.body.classList.add('party-background');
            // Professional confetti sequence
            $aaf54fe06afda49f$var$triggerFireworksConfetti();
            setTimeout(()=>$aaf54fe06afda49f$var$triggerSideCannonConfetti(), 1000);
            setTimeout(()=>$aaf54fe06afda49f$var$triggerStarsConfetti(), 2000);
            setTimeout(()=>$aaf54fe06afda49f$var$triggerRandomConfetti(), 3000);
            // Clean up after 8 seconds
            setTimeout(()=>{
                mainTitle?.classList.remove('rainbow-text');
                document.body.classList.remove('party-background');
            }, 8000);
            break;
        case 1:
            console.log("\uD83C\uDF08 Rainbow Party Mode");
            mainTitle?.classList.add('rainbow-text');
            document.body.classList.add('party-background');
            // Just rainbow effects, no confetti
            setTimeout(()=>{
                mainTitle?.classList.remove('rainbow-text');
                document.body.classList.remove('party-background');
            }, 8000);
            break;
        case 2:
            console.log("\uD83C\uDF88 Professional Balloon Party Mode");
            mainTitle?.classList.add('rainbow-text');
            $aaf54fe06afda49f$var$triggerBalloonsAnimation();
            setTimeout(()=>{
                mainTitle?.classList.remove('rainbow-text');
            }, 8000);
            break;
    }
    // Increment counter for next activation
    $aaf54fe06afda49f$var$partyModeCounter++;
}
// Helper to safely call confetti (handles CDN load failures)
function $aaf54fe06afda49f$var$safeConfetti(options) {
    if (typeof (0, $947b03da4811c942$export$2e2bcd8739ae039) === 'function') (0, $947b03da4811c942$export$2e2bcd8739ae039)(options);
}
// Professional fireworks confetti effect
function $aaf54fe06afda49f$var$triggerFireworksConfetti() {
    if (typeof (0, $947b03da4811c942$export$2e2bcd8739ae039) !== 'function') return;
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        colors: [
            '#FFE400',
            '#FFBD00',
            '#E89400',
            '#FFCA6C',
            '#FDFFB8',
            '#a786ff',
            '#fd8bbc',
            '#eca184',
            '#f8deb1'
        ]
    };
    const randomInRange = (min, max)=>Math.random() * (max - min) + min;
    const interval = setInterval(()=>{
        const timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) return clearInterval(interval);
        const particleCount = 50 * (timeLeft / duration);
        // Left side firework
        $aaf54fe06afda49f$var$safeConfetti({
            ...defaults,
            particleCount: particleCount,
            origin: {
                x: randomInRange(0.1, 0.3),
                y: Math.random() - 0.2
            }
        });
        // Right side firework
        $aaf54fe06afda49f$var$safeConfetti({
            ...defaults,
            particleCount: particleCount,
            origin: {
                x: randomInRange(0.7, 0.9),
                y: Math.random() - 0.2
            }
        });
    }, 250);
}
// Side cannons confetti effect
function $aaf54fe06afda49f$var$triggerSideCannonConfetti() {
    if (typeof (0, $947b03da4811c942$export$2e2bcd8739ae039) !== 'function') return;
    const end = Date.now() + 2000;
    const colors = [
        '#a786ff',
        '#fd8bbc',
        '#eca184',
        '#f8deb1'
    ];
    const frame = ()=>{
        if (Date.now() > end) return;
        $aaf54fe06afda49f$var$safeConfetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            startVelocity: 60,
            origin: {
                x: 0,
                y: 0.5
            },
            colors: colors
        });
        $aaf54fe06afda49f$var$safeConfetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            startVelocity: 60,
            origin: {
                x: 1,
                y: 0.5
            },
            colors: colors
        });
        requestAnimationFrame(frame);
    };
    frame();
}
// Stars confetti effect
function $aaf54fe06afda49f$var$triggerStarsConfetti() {
    if (typeof (0, $947b03da4811c942$export$2e2bcd8739ae039) !== 'function') return;
    const defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: [
            '#FFE400',
            '#FFBD00',
            '#E89400',
            '#FFCA6C',
            '#FDFFB8'
        ]
    };
    const shoot = ()=>{
        $aaf54fe06afda49f$var$safeConfetti({
            ...defaults,
            particleCount: 40,
            scalar: 1.2,
            shapes: [
                'star'
            ]
        });
        $aaf54fe06afda49f$var$safeConfetti({
            ...defaults,
            particleCount: 10,
            scalar: 0.75,
            shapes: [
                'circle'
            ]
        });
    };
    setTimeout(shoot, 0);
    setTimeout(shoot, 100);
    setTimeout(shoot, 200);
}
// Random angle confetti for progressive effects
function $aaf54fe06afda49f$var$triggerRandomConfetti() {
    if (typeof (0, $947b03da4811c942$export$2e2bcd8739ae039) !== 'function') return;
    const angle = Math.random() * 360;
    $aaf54fe06afda49f$var$safeConfetti({
        angle: angle,
        spread: 55,
        particleCount: 100,
        origin: {
            x: 0.5,
            y: 0.8
        },
        colors: [
            '#FFE400',
            '#FFBD00',
            '#E89400',
            '#FFCA6C',
            '#FDFFB8',
            '#a786ff',
            '#fd8bbc'
        ]
    });
}
// Professional balloons animation using balloons-js library
function $aaf54fe06afda49f$var$triggerBalloonsAnimation() {
    // Prefer global (from CDN), otherwise fallback to custom
    if (typeof window !== 'undefined' && typeof window.balloons === 'function') try {
        console.log("\uD83C\uDF88 Using balloons-js (global)");
        window.balloons();
        return;
    } catch (e) {
        console.warn('Global balloons() failed, using fallback...', e);
    }
    $aaf54fe06afda49f$var$createProfessionalBalloons();
}
// Professional balloon fallback (if library fails)
function $aaf54fe06afda49f$var$createProfessionalBalloons() {
    const container = document.createElement('div');
    container.className = 'professional-balloons-container';
    container.style.cssText = `
        position: fixed;
        inset: 0;
        z-index: 999;
        pointer-events: none;
        perspective: 1500px;
        perspective-origin: 50vw 100vh;
        overflow: hidden;
    `;
    document.body.appendChild(container);
    const colorPairs = [
        [
            '#ffec37',
            '#f8b13d'
        ],
        [
            '#f89640',
            '#c03940'
        ],
        [
            '#3bc0f0',
            '#0075bc'
        ],
        [
            '#b0cb47',
            '#3d954b'
        ],
        [
            '#cf85b8',
            '#a3509d'
        ]
    ];
    const amount = Math.max(7, Math.round(window.innerWidth / 120));
    for(let i = 0; i < amount; i++){
        const [balloonColor, lightColor] = colorPairs[Math.floor(Math.random() * colorPairs.length)];
        const balloon = document.createElement('div');
        balloon.className = 'professional-balloon';
        const size = 80 + Math.random() * 40; // Random size 80-120px
        const x = Math.random() * window.innerWidth;
        const z = -Math.random() * 800; // Depth for 3D effect
        const blur = Math.abs(z) / 100; // Blur based on depth for bokeh effect
        balloon.style.cssText = `
            position: absolute;
            left: ${x}px;
            top: 100vh;
            width: ${size}px;
            height: ${size}px;
            background: linear-gradient(135deg, ${balloonColor} 0%, ${lightColor} 100%);
            border-radius: 50%;
            transform: translateX(-50%) translateZ(${z}px);
            filter: blur(${blur}px);
            z-index: ${Math.floor(1000 - Math.abs(z))};
            pointer-events: none;
            --z: ${z}px;
            box-shadow: 
                inset -10px -10px 20px rgba(0,0,0,0.3),
                inset 15px 15px 30px rgba(255,255,255,0.6),
                0 10px 30px rgba(0,0,0,0.2);
            animation: professional-balloon-float ${8 + Math.random() * 4}s ease-out forwards;
            animation-delay: ${i * 200}ms;
        `;
        // Add balloon highlight
        const highlight = document.createElement('div');
        highlight.style.cssText = `
            position: absolute;
            top: 15%;
            left: 25%;
            width: 25%;
            height: 35%;
            background: radial-gradient(ellipse at center, rgba(255,255,255,0.8) 0%, transparent 70%);
            border-radius: 50%;
            transform: rotate(-25deg);
        `;
        balloon.appendChild(highlight);
        // Add balloon string
        const string = document.createElement('div');
        string.style.cssText = `
            position: absolute;
            left: 50%;
            top: 100%;
            width: 2px;
            height: 30px;
            background: linear-gradient(to bottom, #666, #333);
            transform: translateX(-50%);
            border-radius: 1px;
        `;
        balloon.appendChild(string);
        container.appendChild(balloon);
    }
    // Remove container after animation
    setTimeout(()=>container.remove(), 12000);
}


// --- Tunables -------------------------------------------------------------
const $9dd8ce1cdd9c1a7a$var$SPECIAL_ANIMATION_CLICKS = 10; // Jim spins + floats at this many clicks
const $9dd8ce1cdd9c1a7a$var$PARTY_MODE_CLICKS = 20; // party mode fires (and counter resets) here
const $9dd8ce1cdd9c1a7a$var$INCIDENT_RESET_MS = 5000; // "days since last incident" reshuffles on this cadence
const $9dd8ce1cdd9c1a7a$var$ISSUES_PER_PARTY = 3; // party mode fires every Nth logged defect
// --- Cached DOM ----------------------------------------------------------
const $9dd8ce1cdd9c1a7a$var$jimImg = document.getElementById('jim-img');
const $9dd8ce1cdd9c1a7a$var$clickCounter = document.getElementById('click-counter');
const $9dd8ce1cdd9c1a7a$var$clickDisplay = document.getElementById('click-count-display');
const $9dd8ce1cdd9c1a7a$var$issueCount = document.getElementById('issue-count');
const $9dd8ce1cdd9c1a7a$var$daysCounter = document.getElementById('days-counter');
const $9dd8ce1cdd9c1a7a$var$jimAudio = document.getElementById('jim-audio');
const $9dd8ce1cdd9c1a7a$var$issuesList = document.getElementById('jim-issues');
const $9dd8ce1cdd9c1a7a$var$addIssueBtn = document.getElementById('add-issue-btn');
const $9dd8ce1cdd9c1a7a$var$mainTitle = document.getElementById('main-title');
// --- State ---------------------------------------------------------------
let $9dd8ce1cdd9c1a7a$var$jimClickCount = 0;
let $9dd8ce1cdd9c1a7a$var$totalJimClicks = (0, $cuPh8.savedScore)('jim-total-clicks');
let $9dd8ce1cdd9c1a7a$var$konamiSequence = [];
const $9dd8ce1cdd9c1a7a$var$konamiCode = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'KeyB',
    'KeyA'
];
// Additional Jim issues for random adding
const $9dd8ce1cdd9c1a7a$var$additionalJimIssues = [
    {
        text: "Still thinks honking solves traffic",
        severity: "high"
    },
    {
        text: "Probably has truck nuts",
        severity: "medium"
    },
    {
        text: "Listens to music too loudly",
        severity: "low"
    },
    {
        text: "Uses turn signals incorrectly",
        severity: "medium"
    },
    {
        text: "Drives in the left lane going slow",
        severity: "high"
    },
    {
        text: "Has bumper stickers nobody asked for",
        severity: "low"
    },
    {
        text: "Revs engine at red lights",
        severity: "medium"
    },
    {
        text: "Parks across two spaces",
        severity: "high"
    },
    {
        text: "Has opinions about other people's cars",
        severity: "medium"
    },
    {
        text: "Thinks louder equals better",
        severity: "low"
    },
    {
        text: "He thinks he is tall",
        severity: "medium"
    },
    {
        text: "Lunch 2.0",
        severity: "high"
    }
];
// --- Subtle hover blip (Web Audio; lazily created, gracefully degrades) ---
let $9dd8ce1cdd9c1a7a$var$audioCtx = null;
const $9dd8ce1cdd9c1a7a$var$prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function $9dd8ce1cdd9c1a7a$var$playHoverBlip() {
    if ($9dd8ce1cdd9c1a7a$var$prefersReducedMotion.matches || (0, $cuPh8.readSaved)('site-muted') === 'true') return; // honor reduced-motion / reduced-noise intent
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return;
        if (!$9dd8ce1cdd9c1a7a$var$audioCtx) $9dd8ce1cdd9c1a7a$var$audioCtx = new Ctx();
        if ($9dd8ce1cdd9c1a7a$var$audioCtx.state === 'suspended') $9dd8ce1cdd9c1a7a$var$audioCtx.resume();
        const osc = $9dd8ce1cdd9c1a7a$var$audioCtx.createOscillator();
        const gain = $9dd8ce1cdd9c1a7a$var$audioCtx.createGain();
        osc.type = 'sine';
        osc.frequency.value = 440;
        gain.gain.setValueAtTime(0.04, $9dd8ce1cdd9c1a7a$var$audioCtx.currentTime); // intentionally quiet
        gain.gain.exponentialRampToValueAtTime(0.0001, $9dd8ce1cdd9c1a7a$var$audioCtx.currentTime + 0.08);
        osc.connect(gain).connect($9dd8ce1cdd9c1a7a$var$audioCtx.destination);
        osc.start();
        osc.stop($9dd8ce1cdd9c1a7a$var$audioCtx.currentTime + 0.09);
    } catch  {
    // Audio unavailable — silently skip.
    }
}
function $9dd8ce1cdd9c1a7a$var$attachHoverBlip(el) {
    el.addEventListener('mouseenter', $9dd8ce1cdd9c1a7a$var$playHoverBlip);
}
// --- Jim image interaction -----------------------------------------------
function $9dd8ce1cdd9c1a7a$var$handleJimActivation() {
    $9dd8ce1cdd9c1a7a$var$jimClickCount++;
    $9dd8ce1cdd9c1a7a$var$totalJimClicks++;
    (0, $cuPh8.save)('jim-total-clicks', $9dd8ce1cdd9c1a7a$var$totalJimClicks);
    if ($9dd8ce1cdd9c1a7a$var$jimAudio && (0, $cuPh8.readSaved)('site-muted') !== 'true') {
        $9dd8ce1cdd9c1a7a$var$jimAudio.currentTime = 0;
        $9dd8ce1cdd9c1a7a$var$jimAudio.play().catch(()=>{});
    }
    $9dd8ce1cdd9c1a7a$var$updateClickDisplay();
    if ($9dd8ce1cdd9c1a7a$var$clickCounter) $9dd8ce1cdd9c1a7a$var$clickCounter.style.color = `hsl(${$9dd8ce1cdd9c1a7a$var$jimClickCount * 10}, 70%, 50%)`;
    // Make the defect log dance briefly
    document.querySelectorAll('.jim-list li').forEach((item)=>{
        item.style.animation = 'dance 0.5s ease-in-out';
        setTimeout(()=>{
            item.style.animation = '';
        }, 500);
    });
    if ($9dd8ce1cdd9c1a7a$var$jimClickCount === $9dd8ce1cdd9c1a7a$var$SPECIAL_ANIMATION_CLICKS && $9dd8ce1cdd9c1a7a$var$jimImg) $9dd8ce1cdd9c1a7a$var$jimImg.style.animation = 'spin 1s ease-in-out, float 2s ease-in-out infinite 1s';
    if ($9dd8ce1cdd9c1a7a$var$jimClickCount === $9dd8ce1cdd9c1a7a$var$PARTY_MODE_CLICKS) {
        (0, $aaf54fe06afda49f$export$203df52ee0fb1907)();
        $9dd8ce1cdd9c1a7a$var$jimClickCount = 0;
        $9dd8ce1cdd9c1a7a$var$updateClickDisplay();
    }
}
function $9dd8ce1cdd9c1a7a$var$updateClickDisplay() {
    if ($9dd8ce1cdd9c1a7a$var$clickCounter) {
        $9dd8ce1cdd9c1a7a$var$clickCounter.textContent = $9dd8ce1cdd9c1a7a$var$jimClickCount;
        $9dd8ce1cdd9c1a7a$var$clickCounter.hidden = $9dd8ce1cdd9c1a7a$var$jimClickCount === 0;
    }
    if ($9dd8ce1cdd9c1a7a$var$clickDisplay) $9dd8ce1cdd9c1a7a$var$clickDisplay.textContent = $9dd8ce1cdd9c1a7a$var$totalJimClicks;
}
if ($9dd8ce1cdd9c1a7a$var$jimImg) {
    $9dd8ce1cdd9c1a7a$var$jimImg.addEventListener('click', $9dd8ce1cdd9c1a7a$var$handleJimActivation);
    // Keyboard support (it carries role="button" / tabindex="0")
    $9dd8ce1cdd9c1a7a$var$jimImg.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $9dd8ce1cdd9c1a7a$var$handleJimActivation();
        }
    });
}
// --- Konami code ---------------------------------------------------------
document.addEventListener('keydown', (e)=>{
    if (e.target.closest('input, textarea, select')) return;
    $9dd8ce1cdd9c1a7a$var$konamiSequence.push(e.code);
    $9dd8ce1cdd9c1a7a$var$konamiSequence = $9dd8ce1cdd9c1a7a$var$konamiSequence.slice(-$9dd8ce1cdd9c1a7a$var$konamiCode.length);
    if ($9dd8ce1cdd9c1a7a$var$konamiSequence.join(',') === $9dd8ce1cdd9c1a7a$var$konamiCode.join(',')) {
        (0, $aaf54fe06afda49f$export$203df52ee0fb1907)();
        $9dd8ce1cdd9c1a7a$var$konamiSequence = [];
    }
});
// --- Add a defect --------------------------------------------------------
if ($9dd8ce1cdd9c1a7a$var$addIssueBtn && $9dd8ce1cdd9c1a7a$var$issuesList) $9dd8ce1cdd9c1a7a$var$addIssueBtn.addEventListener('click', function() {
    if ($9dd8ce1cdd9c1a7a$var$additionalJimIssues.length === 0) return;
    const randomIndex = Math.floor(Math.random() * $9dd8ce1cdd9c1a7a$var$additionalJimIssues.length);
    const newIssue = $9dd8ce1cdd9c1a7a$var$additionalJimIssues.splice(randomIndex, 1)[0];
    const li = document.createElement('li');
    li.className = `severity-${newIssue.severity}`;
    li.textContent = newIssue.text;
    li.style.opacity = '0';
    li.style.transform = 'translateX(-20px)';
    $9dd8ce1cdd9c1a7a$var$attachHoverBlip(li);
    $9dd8ce1cdd9c1a7a$var$issuesList.appendChild(li);
    // Animate in on the next frame
    requestAnimationFrame(()=>{
        li.style.transition = 'all 0.3s ease';
        li.style.opacity = '1';
        li.style.transform = 'translateX(0)';
    });
    $9dd8ce1cdd9c1a7a$var$updateCriticalIssuesCount();
    const totalIssues = document.querySelectorAll('.jim-list li').length;
    if (totalIssues % $9dd8ce1cdd9c1a7a$var$ISSUES_PER_PARTY === 0) (0, $aaf54fe06afda49f$export$203df52ee0fb1907)();
    if ($9dd8ce1cdd9c1a7a$var$additionalJimIssues.length === 0) {
        this.disabled = true;
        this.textContent = "Defect backlog exhausted \u2014 Jim is beyond repair";
    }
});
function $9dd8ce1cdd9c1a7a$var$updateCriticalIssuesCount() {
    if (!$9dd8ce1cdd9c1a7a$var$issueCount) return;
    $9dd8ce1cdd9c1a7a$var$issueCount.textContent = document.querySelectorAll('.severity-high').length;
    $9dd8ce1cdd9c1a7a$var$issueCount.classList.add('pulse');
    setTimeout(()=>$9dd8ce1cdd9c1a7a$var$issueCount.classList.remove('pulse'), 1000);
}
// Hover blip on the initial defect entries
document.querySelectorAll('.jim-list li').forEach($9dd8ce1cdd9c1a7a$var$attachHoverBlip);
// --- Title hover: glitch + occasional balloons ---------------------------
if ($9dd8ce1cdd9c1a7a$var$mainTitle) {
    let hoverCount = 0;
    $9dd8ce1cdd9c1a7a$var$mainTitle.addEventListener('mouseenter', ()=>{
        $9dd8ce1cdd9c1a7a$var$mainTitle.classList.add('glitch-effect');
        setTimeout(()=>$9dd8ce1cdd9c1a7a$var$mainTitle.classList.remove('glitch-effect'), 500);
        hoverCount++;
        if (hoverCount % 3 === 0) $9dd8ce1cdd9c1a7a$var$createMiniBalloons();
    });
}
// --- "Days since last incident" (resets for comedy) ----------------------
let $9dd8ce1cdd9c1a7a$var$daysSinceIncident = 0;
setInterval(()=>{
    $9dd8ce1cdd9c1a7a$var$daysSinceIncident = $9dd8ce1cdd9c1a7a$var$daysSinceIncident === 0 ? Math.floor(Math.random() * 3) + 1 : 0;
    if ($9dd8ce1cdd9c1a7a$var$daysCounter) $9dd8ce1cdd9c1a7a$var$daysCounter.textContent = $9dd8ce1cdd9c1a7a$var$daysSinceIncident;
}, $9dd8ce1cdd9c1a7a$var$INCIDENT_RESET_MS);
// --- Colorblind-unfriendly mode (list item, header button, big red button)
(function setupColorblindToggles() {
    const headerBtn = document.getElementById('colorblind-toggle');
    const toggleMode = ()=>{
        const on = document.body.classList.toggle('colorblind-mode');
        if (headerBtn) headerBtn.setAttribute('aria-pressed', String(on));
        if (!on) return;
        if ($9dd8ce1cdd9c1a7a$var$jimAudio && (0, $cuPh8.readSaved)('site-muted') !== 'true') {
            $9dd8ce1cdd9c1a7a$var$jimAudio.currentTime = 0;
            $9dd8ce1cdd9c1a7a$var$jimAudio.play().catch(()=>{});
        }
        if (!$9dd8ce1cdd9c1a7a$var$prefersReducedMotion.matches) (0, $947b03da4811c942$export$2e2bcd8739ae039)({
            particleCount: 50,
            spread: 90,
            colors: [
                '#ff0000',
                '#00ff00',
                '#ff0000',
                '#00ff00'
            ],
            origin: {
                y: 0.5
            }
        });
        setTimeout((0, $aaf54fe06afda49f$export$203df52ee0fb1907), 500);
    };
    document.getElementById('colorblind-item')?.addEventListener('click', toggleMode);
    headerBtn?.addEventListener('click', toggleMode);
    document.getElementById('cool-mode-btn')?.addEventListener('click', function() {
        toggleMode();
        this.style.transform = 'scale(0.95)';
        setTimeout(()=>{
            this.style.transform = '';
        }, 100);
    });
})();
// --- Mini balloons (lightweight, center area) ----------------------------
function $9dd8ce1cdd9c1a7a$var$createMiniBalloons() {
    if ($9dd8ce1cdd9c1a7a$var$prefersReducedMotion.matches) return;
    const container = document.createElement('div');
    container.style.cssText = 'position:fixed; inset:0; z-index:999; pointer-events:none; overflow:hidden;';
    document.body.appendChild(container);
    const colors = [
        '#ff6b6b',
        '#4ecdc4',
        '#45b7d1',
        '#f9ca24',
        '#6c5ce7'
    ];
    const amount = 3;
    for(let i = 0; i < amount; i++)setTimeout(()=>{
        const balloon = document.createElement('div');
        const color = colors[Math.floor(Math.random() * colors.length)];
        const size = 30 + Math.random() * 20;
        const x = window.innerWidth * 0.3 + Math.random() * window.innerWidth * 0.4;
        balloon.style.cssText = `position:absolute; left:${x}px; bottom:-100px; width:${size}px; height:${size}px; background:${color}; border-radius:50%; opacity:0.8; animation: professional-balloon-float ${4 + Math.random() * 2}s ease-out forwards;`;
        container.appendChild(balloon);
    }, i * 100);
    setTimeout(()=>container.remove(), 6000);
}
// --- Footer year ---------------------------------------------------------
const $9dd8ce1cdd9c1a7a$var$footerYear = document.getElementById('footer-year');
if ($9dd8ce1cdd9c1a7a$var$footerYear) $9dd8ce1cdd9c1a7a$var$footerYear.textContent = new Date().getFullYear();
// --- Initialize ----------------------------------------------------------
$9dd8ce1cdd9c1a7a$var$updateCriticalIssuesCount();
$9dd8ce1cdd9c1a7a$var$updateClickDisplay();


//# sourceMappingURL=JimSucks.1aa21797.js.map
